import type React from 'react';

type Props = {
  children: string;
  options: Record<string, (item: string, key: string) => React.ReactNode>;
};

/**
 * Takes an options object where keys are strings and values are functions.
 * It splits the children into an array based on the keys.
 * For example: "I love @depop for #vintage#clothing." will result into ["I love", "@depop" "for", "#vintage", "#clothing"]
 * It will iterate over this array and for each string that starts with one of the keys will execute the render prop
 */
export function DescriptionParser({ children, options }: Props) {
  const rgx = new RegExp(`([${Object.keys(options).join('')}]\\w+)`, 'g');
  const tokenized = children.split(rgx);

  return tokenized.map((item) => {
    for (const key in options) {
      if (item.startsWith(key) && item.match(rgx)) {
        return options[key](item, item);
      }
    }
    return item;
  });
}
